<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">16PF</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="pf16Form" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Datos de la pregunta</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="row" formGroupName="opcA">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción A</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div class="form-group">
                                        <label class="control-label">Puntaje opción A</label>
                                        <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción A">
                                    </div>
                                </div>
                            </div>

                            <div class="row" formGroupName="opcB">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción B</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div class="form-group">
                                        <label class="control-label">Puntaje opción B</label>
                                        <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción B">
                                    </div>
                                </div>
                            </div>

                            <div class="row" formGroupName="opcC">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción C</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div class="form-group">
                                        <label class="control-label">Puntaje opción C</label>
                                        <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción C">
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Factor</label>
                                    <select formControlName="factor" class="form-control custom-select">
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                        <option value="E">E</option>
                                        <option value="F">F</option>
                                        <option value="G">G</option>
                                        <option value="H">H</option>
                                        <option value="I">I</option>
                                        <option value="L">L</option>
                                        <option value="M">M</option>
                                        <option value="N">N</option>
                                        <option value="O">O</option>
                                        <option value="Q1">Q1</option>
                                        <option value="Q2">Q2</option>
                                        <option value="Q3">Q3</option>
                                        <option value="Q4">Q4</option>

                                    </select>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Guardar</button>
                        <button type="button" class="btn btn-inverse" (click)="reset()">Reiniciar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>